// src/pages/Contact.js
import React from "react";
import "./PageStyles.css";

const Contact = () => {
  return (
    <section className="page-section">
      <h1>Contact Us</h1>
      <p>Get in touch with our coordination team for partnerships or participation details.</p>
      <ul>
        <li>Email: contact@ottomun.org</li>
        <li>Phone: +90 555 123 4567</li>
        <li>Location: Istanbul, Türkiye</li>
      </ul>
    </section>
  );
};

export default Contact;
